import React from "react"
import { Card, Col, Container, Row } from "reactstrap"
import { T } from "../traks"
import { site_name } from "../Site"
import { getPremiumUpgradeTarget } from '../misc';

export const TryForFree = () => {
  return (
    <Container>
      <Card className="my-5 p-0 rounded-4 shadow-sm try-free">
        <a href={getPremiumUpgradeTarget()} className="stretched-link text-decoration-none text-reset">
        <Row className="align-items-center p-3 p-lg-4">
            <Col xs="12" md="auto" className="d-flex align-items-center justify-content-center try-free-floating">
                <img
                className="img-fluid flex-shrink-0 try-free__img"
                src="https://static.aktiedysten.dk/gfx/hat-books-globe184x184.png"
                alt="Diversification"
                />
            </Col>

            <Col xs="12" md className="text-left text-md-start">
                <h1 className="txt-40px fw_800 mb-1">
                <T>Try {site_name} for free</T>
                </h1>

                <p className="mb-0 fw_700 txt-20px">
                <T>Invite up to</T>&nbsp;
                <span className="premium-green txt-20px">30&nbsp;</span>
                <T>friends, colleagues or students and compete for the best investor title</T>
                </p>
            </Col>
            </Row>
      </a>
      </Card>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/c/TryForFree.js